<!--
 * @Description: 地址信息
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-14 18:52:14
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-11-07 12:11:40
-->
<template>
  <div class="address-list-col-page">
    <special-head title="地址信息">
      <template #extra>
        <div v-if="userInfo?.roles?.indexOf('customer:addAddress') !== -1 && buttons.indexOf('customer:addAddress') > -1 && permission == 1">
          <jw-button type="text" size="small" @click="addAdress" class="add-address-button"><qfei-icon-add-two-outlined />{{ $t('新建') }}</jw-button>
        </div>
      </template>
    </special-head>

    <div class="address-list">
      <jw-spin v-if="loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin>
      <template v-if="addAdressList?.length > 0">
        <div class="address-list-item" v-for="item in addAdressList" :key="item.id">
          <special-card>
            <template #title>
              <div class="address-list-item-title">
                <jw-radio class="edit-delete-edit" v-model="item.isDefault" @change="defaultAddress(item)"> {{ $t(item.isDefault ? '默认' : '设为默认') }} </jw-radio>
                <span class="item-title-line">|</span>

                <span class="address-list-item-title-span">{{ item.label || '-' }}</span>
              </div>
            </template>

            <template #more>
              <jw-dropdown v-if="hasEditButton || hasDelButton">
                <jw-button type="text" size="small" class="handle-btn-more"><qfei-icon-more-applications-outlined /></jw-button>

                <template #content>
                  <jw-doption v-if="hasEditButton" @click="editAddress(item)">{{ $t('修改') }}</jw-doption>
                  <jw-doption v-if="hasDelButton" @click="deleteAddress(item)">{{ $t('删除') }}</jw-doption>
                </template>
              </jw-dropdown>
            </template>

            <div class="address-item-content">
              <div class="address-content-item">
                <span class="item-label">{{ $t('省份-城市') }}</span>
                <span class="item-value"> {{ item.provinceCity || '-' }}</span>
              </div>

              <div class="address-content-item">
                <span class="item-label">{{ $t('详细地址') }}</span
                ><span class="item-value">{{ item.addressDetail || '-' }}</span>
              </div>

              <div class="address-content-item">
                <span class="item-label">{{ $t('邮政编码') }}</span
                ><span class="item-value">{{ item.postCode || '-' }}</span>
              </div>

              <div class="address-content-item">
                <span class="item-label">{{ $t('备注') }}</span
                ><span class="item-value">{{ item.comment || '-' }}</span>
              </div>

              <div class="address-content-item">
                <span class="item-label">{{ $t('创建时间') }}</span
                ><span class="item-value">{{ item.gmtCreated || '-' }}</span>
              </div>

              <div class="address-content-item">
                <span class="item-label">{{ $t('创建人') }}</span>
                <xl-avatar v-if="item.createUserName" :avatar="{ name: item?.createUserName || '', url: item?.createUserAvatarOrigin, id: item?.createUser }" :size="20" />
                <template v-else>-</template>
              </div>
            </div>
          </special-card>
        </div>
      </template>
      <template v-else>
        <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"> {{ $t('tips.notAddress') }} </jw-empty>
      </template>
    </div>
    <!-- 编辑新增 -->
    <update-address-modal ref="updateAddressRefs" @cb="getAdressList"></update-address-modal>
    <!-- 删除提示 -->
    <template>
      <jw-modal v-model:visible="removeVisible" :ok-loading="loading" @ok="removeOk" @cancel="removeCancel" title-align="start">
        <template #title> {{ $t('温馨提示') }} </template>
        <div>{{ $t('确认移除该地址信息') }}？</div>
      </jw-modal>
    </template>
  </div>
</template>
<script setup>
import { ref, inject, onMounted, computed } from 'vue';
import useLoading from '@/hooks/loading';
import imgSvg from '@/assets/images/img-no-record.svg';
import { clientService, layoutService } from '@/api/';
import updateAddressModal from './update-address/index.vue';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { Message } from '@arco-design/web-vue';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import SpecialCard from '@/components/fh-detail/components/special-card/index.vue';

const { loading, setLoading } = useLoading(false);

const id = inject('detailParams').id;
const entity = inject('detailParams')?.entity;
const permission = inject('detailParams')?.permission; //协作人权限
const removeVisible = ref(false);
const { t } = useI18n();
const addressId = ref();
const { userInfo } = useUserStore(); //用户信息
setLoading(false);
const addAdressList = ref([
  // { id: 1, city: '河南郑州', address: '金科城', code: '45555', remake: '这是备注', time: '2023-98-34 24：56：45', userName: '胡彩丽', avatar: 'https://s1-imfile.feishucdn.com/static-resource/v1/v2_4159f234-6abe-4762-8b42-36f9df63fdcg~?image_size=noop&cut_type=&quality=&format=png&sticker_format=.webp', createUser: '123', check: true },
  // { id: 2, city: '河南郑州', address: '金科城', code: '45555', remake: '这是备注', time: '2023-98-34 24：56：45', userName: '胡彩丽', avatar: 'https://s1-imfile.feishucdn.com/static-resource/v1/v2_4159f234-6abe-4762-8b42-36f9df63fdcg~?image_size=noop&cut_type=&quality=&format=png&sticker_format=.webp', createUser: '123', check: false }
]);
const updateAddressRefs = ref();

// 是否有编辑权限
const hasEditButton = computed(() => {
  return userInfo?.roles?.indexOf('customer:editAddress') !== -1 && buttons.value.indexOf('customer:editAddress') > -1 && permission.value == 1;
});

// 是否有删除权限
const hasDelButton = computed(() => {
  return userInfo?.roles?.indexOf('customer:delAddress') !== -1 && buttons.value.indexOf('customer:delAddress') > -1 && permission.value == 1;
});

const customerName = inject('detailParams')?.customerName; //客户名称
const addAdress = () => {
  const params = {
    from: 1,
    title: t('新增地址信息'),
    list: {
      customId: id,
      custom: customerName
    }
  };
  updateAddressRefs.value.updateAddressOpen(params);
};
const getAdressList = async () => {
  addAdressList.value = [];
  setLoading(true);
  console.log(id.value);
  try {
    const res = await clientService.getAddressList({ customId: id.value });
    console.log(res);
    addAdressList.value = res?.result;
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
const defaultAddress = async (record) => {
  // 默认地址
  try {
    const res = await clientService.updateAddress({ id: record.id, customId: id.value });
    console.log(res);
    if (res.error) {
      Message.error(res.error?.msg || t('操作失败'));
      return;
    }
    Message.success(t('操作成功'));
    addAdressList.value?.map((item) => {
      item.isDefault = false;
      if (item.id == record.id) {
        item.isDefault = true;
      }
    });
    // getInvoiceList();
  } catch (e) {
    console.log(e);
  }
};
const editAddress = (record) => {
  //编辑
  const params = {
    from: 0,
    title: t('编辑地址信息'),
    list: {
      ...record,
      custom: customerName,
      customId: id
    }
  };
  updateAddressRefs.value.updateAddressOpen(params);
};

const deleteAddress = (record) => {
  //删除
  addressId.value = record.id;
  removeVisible.value = true;
};
const removeCancel = () => {
  removeVisible.value = false;
};
const removeOk = async () => {
  setLoading(true);
  try {
    const res = await clientService.delAddress({ id: addressId.value });
    console.log(res);
    setLoading(false);
    if (res.error) {
      Message.error(res.error?.msg || t('操作失败'));
      return;
    }
    Message.success(t('操作成功'));
    getAdressList();
    removeVisible.value = false;
  } catch (e) {
    console.log(e);
    setLoading(false);
    removeVisible.value = false;
  }
};
onMounted(() => {
  getAdressList();
  getDetail();
});

const props = defineProps({
  moduleId: {
    type: String,
    default: ''
  }
});
const buttons = ref([]);
const getDetail = async () => {
  if (!props?.moduleId) {
    return false;
  }
  try {
    const params = {
      entity: entity.value,
      moduleId: props.moduleId,
      businessId: id.value,
      apiIndex: props.moduleId
    };
    const json = await layoutService.getDetail(params);
    if (!json.error) {
      const _buttons = [];
      json?.result?.map((b) => {
        _buttons.push(b.value);
      });
      buttons.value = _buttons;
    }
  } catch (e) {
    console.log(e);
  }
};
// 抛出方法
defineExpose({
  getAdressList
});
</script>
<style scoped lang="less">
@import './index.less';
</style>
